import api from "../api";

export const isScreeningStarting = (screening?: api.CustomerScreeningStatus) =>
  ["NOT_STARTED", "STARTING"].includes(screening?.screening_status || "");

export const isScreeningActive = (screening?: api.CustomerScreeningStatus) =>
  screening?.screening_status === "MONITORING" && screening?.screening_type === "MONITORING";
